// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file locks.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file locks.proto.
 */
export const file_locks: GenFile = /*@__PURE__*/
  fileDesc("Cgtsb2Nrcy5wcm90bxIGZG9tYWluItcBChBWYXVsdFByb2ZpbGVMb2NrEhoKEmxvY2tpbmdfcHJvZmlsZV9pZBgBIAEoCRIpCiFsb2NraW5nX3Byb2ZpbGVfa2V5X2dlbmVyYXRpb25faWQYAiABKAkSJAocZW5jcnlwdGVkX3N0b3JhYmxlX3ZhdWx0X2tleRgDIAEoDBIpCiFlbmNyeXB0ZWRfaGlnaF9zZWN1cml0eV92YXVsdF9rZXkYBCABKAwSKwojZW5jcnlwdGVkX3ZhdWx0X21lc3NhZ2VfcHJpdmF0ZV9rZXkYBSABKAwiwgEKGFByb2ZpbGVBdXRoZW50aWNhdG9yTG9jaxIYChBhdXRoZW50aWNhdG9yX2lkGAEgASgJEiwKJGVuY3J5cHRlZF9oaWdoX3NlY3VyaXR5X3Byb2ZpbGVfc2VlZBgCIAEoDBInCh9lbmNyeXB0ZWRfc3RvcmFibGVfcHJvZmlsZV9zZWVkGAMgASgMEhIKCnByb2ZpbGVfaWQYBCABKAkSIQoZcHJvZmlsZV9rZXlfZ2VuZXJhdGlvbl9pZBgFIAEoCSLaAQoVVmF1bHRMb2NrQ3JlYXRpb25EYXRhEhAKCHZhdWx0X2lkGAEgASgJEhUKDWdlbmVyYXRpb25faWQYAiABKAkSJgoEbG9jaxgDIAEoCzIYLmRvbWFpbi5WYXVsdFByb2ZpbGVMb2NrEhsKE2Fzc29jaWF0ZWRfdmF1bHRfaWQYBCABKAkSIAoYYXNzb2NpYXRlZF9nZW5lcmF0aW9uX2lkGAUgASgJEjEKD2Fzc29jaWF0ZWRfbG9jaxgGIAEoCzIYLmRvbWFpbi5WYXVsdFByb2ZpbGVMb2NrIukBChJQcm9maWxlUHJvZmlsZUxvY2sSGgoSbG9ja2luZ19wcm9maWxlX2lkGAEgASgJEikKIWxvY2tpbmdfcHJvZmlsZV9rZXlfZ2VuZXJhdGlvbl9pZBgCIAEoCRIsCiRlbmNyeXB0ZWRfaGlnaF9zZWN1cml0eV9wcm9maWxlX3NlZWQYAyABKAwSJwofZW5jcnlwdGVkX3N0b3JhYmxlX3Byb2ZpbGVfc2VlZBgEIAEoDBISCgpwcm9maWxlX2lkGAUgASgJEiEKGXByb2ZpbGVfa2V5X2dlbmVyYXRpb25faWQYBiABKAlCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z");

/**
 * @generated from message domain.VaultProfileLock
 */
export type VaultProfileLock = Message<"domain.VaultProfileLock"> & {
  /**
   * @generated from field: string locking_profile_id = 1;
   */
  lockingProfileId: string;

  /**
   * @generated from field: string locking_profile_key_generation_id = 2;
   */
  lockingProfileKeyGenerationId: string;

  /**
   * @generated from field: bytes encrypted_storable_vault_key = 3;
   */
  encryptedStorableVaultKey: Uint8Array;

  /**
   * @generated from field: bytes encrypted_high_security_vault_key = 4;
   */
  encryptedHighSecurityVaultKey: Uint8Array;

  /**
   * @generated from field: bytes encrypted_vault_message_private_key = 5;
   */
  encryptedVaultMessagePrivateKey: Uint8Array;
};

/**
 * Describes the message domain.VaultProfileLock.
 * Use `create(VaultProfileLockSchema)` to create a new message.
 */
export const VaultProfileLockSchema: GenMessage<VaultProfileLock> = /*@__PURE__*/
  messageDesc(file_locks, 0);

/**
 * @generated from message domain.ProfileAuthenticatorLock
 */
export type ProfileAuthenticatorLock = Message<"domain.ProfileAuthenticatorLock"> & {
  /**
   * @generated from field: string authenticator_id = 1;
   */
  authenticatorId: string;

  /**
   * @generated from field: bytes encrypted_high_security_profile_seed = 2;
   */
  encryptedHighSecurityProfileSeed: Uint8Array;

  /**
   * @generated from field: bytes encrypted_storable_profile_seed = 3;
   */
  encryptedStorableProfileSeed: Uint8Array;

  /**
   * only set during authenticator creation
   *
   * @generated from field: string profile_id = 4;
   */
  profileId: string;

  /**
   * @generated from field: string profile_key_generation_id = 5;
   */
  profileKeyGenerationId: string;
};

/**
 * Describes the message domain.ProfileAuthenticatorLock.
 * Use `create(ProfileAuthenticatorLockSchema)` to create a new message.
 */
export const ProfileAuthenticatorLockSchema: GenMessage<ProfileAuthenticatorLock> = /*@__PURE__*/
  messageDesc(file_locks, 1);

/**
 * @generated from message domain.VaultLockCreationData
 */
export type VaultLockCreationData = Message<"domain.VaultLockCreationData"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: domain.VaultProfileLock lock = 3;
   */
  lock?: VaultProfileLock | undefined;

  /**
   * @generated from field: string associated_vault_id = 4;
   */
  associatedVaultId: string;

  /**
   * @generated from field: string associated_generation_id = 5;
   */
  associatedGenerationId: string;

  /**
   * @generated from field: domain.VaultProfileLock associated_lock = 6;
   */
  associatedLock?: VaultProfileLock | undefined;
};

/**
 * Describes the message domain.VaultLockCreationData.
 * Use `create(VaultLockCreationDataSchema)` to create a new message.
 */
export const VaultLockCreationDataSchema: GenMessage<VaultLockCreationData> = /*@__PURE__*/
  messageDesc(file_locks, 2);

/**
 * @generated from message domain.ProfileProfileLock
 */
export type ProfileProfileLock = Message<"domain.ProfileProfileLock"> & {
  /**
   * @generated from field: string locking_profile_id = 1;
   */
  lockingProfileId: string;

  /**
   * @generated from field: string locking_profile_key_generation_id = 2;
   */
  lockingProfileKeyGenerationId: string;

  /**
   * @generated from field: bytes encrypted_high_security_profile_seed = 3;
   */
  encryptedHighSecurityProfileSeed: Uint8Array;

  /**
   * @generated from field: bytes encrypted_storable_profile_seed = 4;
   */
  encryptedStorableProfileSeed: Uint8Array;

  /**
   * only set if lock is not sent as part of a profile
   *
   * @generated from field: string profile_id = 5;
   */
  profileId: string;

  /**
   * @generated from field: string profile_key_generation_id = 6;
   */
  profileKeyGenerationId: string;
};

/**
 * Describes the message domain.ProfileProfileLock.
 * Use `create(ProfileProfileLockSchema)` to create a new message.
 */
export const ProfileProfileLockSchema: GenMessage<ProfileProfileLock> = /*@__PURE__*/
  messageDesc(file_locks, 3);

